module.exports = __webpack_public_path__ + "img/photo-0055.c4e11b0d.jpg";